import { Application } from "@hotwired/stimulus"
import ProvisionController from "./controllers/provision-controller"
import SectionController from "./controllers/section-controller"
import StandardController from "./controllers/standard-controller"
import SectionProvisionsController from "./controllers/section-provisions-controller"
import TocLinkController from "./controllers/toc-link-controller"
import ProvisionNavController from "./controllers/provision-nav-controller"
import ToggleSubmitController from "./controllers/toggle-submit-controller"

window.Stimulus = Application.start()

/* eslint-disable no-undef -- window.Stimulus assigned above; bare name matches pre-bundle pattern */
Stimulus.register("provision", ProvisionController)
Stimulus.register("section", SectionController)
Stimulus.register("standard", StandardController)
Stimulus.register("section-provisions", SectionProvisionsController)
Stimulus.register("toc-link", TocLinkController)
Stimulus.register("provision-nav", ProvisionNavController)
Stimulus.register("toggle-submit", ToggleSubmitController)
/* eslint-enable no-undef */
